<p-panel header="{{ 'fs.res.patent.Patent.rightsOfUse' | hisUi }}">

    <!-- #anchor dynamic field container -->
    <ng-template #dynamicFieldContainer></ng-template>

    <!-- no record found -->
    <div class="infoMessage" *ngIf="!researchContracts?.length" [innerHTML]="'fs.res.patent.noRightsOfUseAssigned' | hisUi"></div>
    <button *ngIf="!getIsEditMode()" (click)="setIsEditMode(true)" hisImage="plus_circ_green" class="transparent">
        <span>{{ 'fs.res.patent.addRighOfUse' | hisUi }}</span></button>

    <div *ngIf="getIsEditMode()">
        <p-autoComplete #content [forceSelection]="true" field="defaulttext" [dropdown]="true"
                        [(ngModel)]="selectedOption"
                        [suggestions]="filteredOptions" (completeMethod)="completeMethod($event)"
                        (onSelect)="onSelect($event.value)" class="autocompleteWidth60">
        </p-autoComplete>
    </div>

    <p-table *ngIf="filteredResearchContracts && filteredResearchContracts.length > 0"
             [value]="filteredResearchContracts" [paginator]="filteredResearchContracts.length > 10" [rows]="10">
        <ng-template pTemplate="header">
            <tr>
                <th [pSortableColumn]="'budgetSource.defaulttext'">
                    {{ 'fs.res.common.finance.ResearchContract.budgetSourceCategory.rightOfUse' | hisUi }}
                    <p-sortIcon *ngIf="researchContracts.length > 1" [field]="'budgetSource.defaulttext'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'budgetSource.validFrom'">
                    {{ 'fs.res.patent.Patent.researchContract.budgetSource.validFrom' | hisUi }}
                    <p-sortIcon *ngIf="researchContracts.length > 1" [field]="'validFrom'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'budgetSource.validTo'">
                    {{ 'fs.res.patent.Patent.researchContract.budgetSource.ValidTo' | hisUi }}
                    <p-sortIcon *ngIf="researchContracts.length > 1" [field]="'validTo'"></p-sortIcon>
                </th>
                <th>{{ 'common.actions' | hisUi }}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-researchContract>
            <tr>
                <td>{{researchContract.budgetSource.defaulttext}}</td>
                <td>{{researchContract.budgetSource.validFrom | date: dateFormat}}</td>
                <td>{{researchContract.budgetSource.validTo | date: dateFormat}}</td>
                <td class="singleLine">
                    <button (click)="deleteBudgetSource(researchContract)" hisImage="DELETE" class="icon"
                        title="{{'common.removeAssignmentOf'| hisUi:getBudgetSourceAndOrganization(researchContract)}}"></button>
                </td>
            </tr>
        </ng-template>
    </p-table>

    <!-- can not remove property rights if there are related incomes assigned -->
    <res-information-dialog></res-information-dialog>

    <!-- #anchor dynamic field container -->
    <ng-template #dynamicFieldContainer></ng-template>
</p-panel>
